import PropTypes from 'prop-types';

export default PropTypes.shape({
  node: PropTypes.shape({
    sizes: PropTypes.string.iRequired,
    srcSet: PropTypes.string.iRequired,
    sourceUrl: PropTypes.string.iRequired,
    guid: PropTypes.string.iRequired,
    slug: PropTypes.string,
  })
});
